import React from 'react';
import { CONFIG } from '../../config/config';
import './Buy3Banner.css';

const Buy3Banner = ({ className = '' }) => {
  if (!CONFIG.SALE.ENABLE_BUY3_GET1 || !CONFIG.SALE.SHOW_BANNER) return null;

  const raw = CONFIG.SALE.BANNER_TEXT || '';
  const hasFire = raw.includes('🔥');
  const line = raw.replace(/🔥/g, '').replace(/\s+/g, ' ').trim();

  return (
    <div className={`buy3-banner ${className}`} role="status">
      <div className="buy3-banner-inner">
        <span className="buy3-banner-icon" aria-hidden="true">
          🛍
        </span>
        <p className="buy3-banner-copy">
          <span className="buy3-banner-strong">{line}</span>
          {hasFire && (
            <span className="buy3-banner-emoji" aria-hidden="true"> 🔥</span>
          )}
        </p>
      </div>
    </div>
  );
};

export default Buy3Banner;
